import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'


const AppLink = (
  {
    to,
    alt,
    className = '',
    onClick = () => {},
    disableNewTab = false,
    openNewTab = false,
    rel = 'noopener noreferrer',
    children,
    lookupLinkData,
    setTargetComponent,
    ariaLabel,
    ...extra
  }) => {
  if(!to) return null
  const openingNewTab = (openNewTab && !disableNewTab) || to.match('http')
  const baseProps = {
    className,
    alt,
    // set target component to exit current page component right away on link click
    onClick: !openingNewTab && lookupLinkData ? (e) => {
      if(!e.metaKey && !e.ctrlKey) {
        setTargetComponent(lookupLinkData)
      }

      onClick(e)
    } : onClick,
  }
  if(extra['data-test-id']) {
    baseProps['data-test-id'] = extra['data-test-id']
  }
  /* eslint-disable */
  if(openingNewTab) {
    return (
      <a
        {...baseProps}
        href={to}
        // although rel defaultProps has noopener noreferrer, linter seems to fail catching it
        target="_blank"
        rel={rel}
        aria-label={ariaLabel}
      >
        {children}
      </a>
    )
  }

  /* eslint-enable */
  return (
    <Link {...baseProps} to={to} aria-label={ariaLabel}>
      {children}
    </Link>
  )
}


AppLink.propTypes = {
  to: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  setTargetComponent: PropTypes.func,
  id: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  // only for the link from fb browser
  disableNewTab: PropTypes.bool,
  openNewTab: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.node, PropTypes.string]).isRequired,
  lookupLinkData: PropTypes.shape({
    component: PropTypes.string,
    id: PropTypes.number,
    pageData: PropTypes.shape({}),
  }),
  ariaLabel: PropTypes.string,
}

export default AppLink
